import React, {useEffect, useState} from 'react';
import {Modal as FlowbiteModal} from "flowbite-react";

import {deleteMessage} from "../../services/chatMessages";
import Close from "../../assets/close.svg";
import {useMutation} from "@tanstack/react-query";

interface ModalProps {
    messageId: string | null;
    isOpen: boolean;
    onClose: () => void;
    onDelete: (messageId: string) => void;
}

export const MessageRemoveModal = ({isOpen, onClose, onDelete, messageId}: ModalProps) => {
    const [pk, setPk] = useState<string | null>(null);
    // Модальное окно с редактированием файлов сотрудника

    // Запрос на удаление
    const {mutate: deleteMsg, isPending} = useMutation({
        mutationFn: ({pk}: {
            pk: string,
        }) => deleteMessage(pk),
        onSuccess: (data) => {
            onDelete(pk || '');
        }
    });

    useEffect(() => {
        if (messageId) {
            setPk(messageId)
        }
    }, [messageId]);

    const handleRemove = () => {
        if (pk) {
            deleteMsg({pk})
        }
    }
    return (
        <FlowbiteModal
            show={isOpen}
            onClose={onClose}
            size={'md'}
        >
            <div
                className="w-full inline-flex flex-col items-start p-8 relative bg-white rounded-lg overflow-hidden">
                {/*CONTAINER*/}
                <div className="w-full inline-flex flex-col items-start relative flex-[0_0_auto]">
                    {/*HEADER*/}
                    <div
                        className="
                        relative
                        w-full flex flex-row justify-end items-center text-black text-2xl
                        leading-[normal]
                        [font-family:'Acrom-Medium',Helvetica] font-medium tracking-[0]
                        "
                    >
                        {/*CLOSE BUTTON*/}
                        <button
                            onClick={onClose}
                            className="flex justify-center items-center w-8 h-8 top-2.5 bg-[#f2f2f2] rounded-lg overflow-hidden">
                            <img src={Close} className=" w-6 h-6" alt="Manager ic close"/>
                        </button>
                    </div>
                    {/*BODY*/}
                    <div className="w-full inline-flex flex-col items-start gap-8 relative flex-[0_0_auto]">
                        <div className=" text-2xl text-center">
                            Удалить выбранное сообщение?
                        </div>
                    </div>
                    {/*BUTTONS*/}
                    <div className="w-full flex flex-col mt-5 gap-5 justify-center items-center">
                        <button
                            onClick={handleRemove}
                            disabled={isPending}
                            className={"w-full inline-flex flex-col items-start gap-2.5 px-5 py-3.5 relative flex-[0_0_auto] rounded-lg overflow-hidden " + (isPending ? "bg-gray-100" : "bg-melon-yellow")}>
                            <div
                                className="
                                w-full
                                flex items-center justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                "
                            >
                                Удалить
                            </div>
                        </button>
                        <button
                            onClick={onClose}
                            className="
                            w-full inline-flex flex-col
                            items-start gap-2.5 px-5 py-3.5 relative flex-[0_0_auto] bg-gray-100 rounded-lg overflow-hidden">
                            <div
                                className="
                                w-full
                                flex items-center justify-center
                                font-manager-acrom-button4-16-medium-acrom
                                font-[number:var(--manager-acrom-button4-16-medium-acrom-font-weight)]
                                text-black text-[length:var(--manager-acrom-button4-16-medium-acrom-font-size)]
                                text-center tracking-[var(--manager-acrom-button4-16-medium-acrom-letter-spacing)]
                                leading-[var(--manager-acrom-button4-16-medium-acrom-line-height)]
                                [font-style:var(--manager-acrom-button4-16-medium-acrom-font-style)]
                                "
                            >
                                Отменить
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </FlowbiteModal>
    );
};